/**
 * 设置商品
 */

import { HTTP_ALB } from "../axios";

// //  设置商品列表
// export const getappshoplist = (params) => {
//   return HTTP_ALB.get("/foundation/live/app_shop_list", params);
// };

// // 编辑设置商品
// export const editappshop = (params) => {
//   return HTTP_ALB.post("/foundation/live/app_shop_edit", params);
// };


// 获取品牌主下的商品列表
export const getappbrandshop = (params) => {
  return HTTP_ALB.get("/foundation/live/app_brand_shop", params);
};

// 商品 关联 SKUID
export const livejoin_shop = (params) => {
  return HTTP_ALB.post("/foundation/live/join_shop", params);
};

// 添加商品
export const addappshop = (params) => {
  return HTTP_ALB.post("/foundation/live/app_shop_add", params);
};

// 删除商品
export const deleteappshop = (params) => {
  return HTTP_ALB.post("/foundation/live/app_shop_del", params);
};
// 场次列表
export const getsessionlist = (params) => {
  return HTTP_ALB.get("/foundation/live/list", params);
};
// 抖音企业号场次列表
export const getcluerichSessionlist = (params) => {
  return HTTP_ALB.get("/live/cluerich/session", params);
};
// 修改场次列表
export const editsessionlive = (params) => {
  return HTTP_ALB.post("/foundation/live/edit", params);
};
// 企业号修改场次列表
export const editsessionliveCluerich = (params) => {
  return HTTP_ALB.post("/live/cluerich/sessionedit", params);
};
// 添加场次列表
export const addlivesession = (params) => {
  return HTTP_ALB.post("/foundation/live/add", params);
};

// 场次列表回显
export const livesessioninfo = (params) => {
  return HTTP_ALB.get("/foundation/live/info", params);
};

// 企业号场次列表回显
export const livesessioninfoCluerich = (params) => {
  return HTTP_ALB.get("/live/cluerich/sessioninfo", params);
};


// 场次下商品列表
export const getappshopall = (params) => {
  return HTTP_ALB.get('/foundation/live/app_shop_all', params)
}

// // 关联电商侧商品
// export const appshopjoin = (params) => {
//   return HTTP_ALB.post('/foundation/live/app_shop_join', params)
// }


// // 解除关联电商侧商品
// export const appshopjoindel = (params) => {
//   return HTTP_ALB.post('/foundation/live/app_shop_join_del', params)
// }